import { Alert } from '@ps/isp-web-component-library';
import type { Odds as OddsType } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Odds } from '@swf/sports/components/Odds/Odds';

import { TXTWCL_We_are_unable_to_place_this_be_ELL } from './MinOddsAlert.messages.json';

interface Props {
  minOdds: OddsType;
}

const MinOddsAlert: React.FC<Props> = ({ minOdds }) => (
  <Alert level="destructive" variant="passive-aggressive">
    <Translation
      {...TXTWCL_We_are_unable_to_place_this_be_ELL}
      values={{
        0: <Odds {...minOdds} />
      }}
    />
  </Alert>
);

export default MinOddsAlert;
